import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { GET, POST } from '../../../../Services';
import { notification } from 'antd';

const API_URL = import.meta.env.VITE_API_URL;
const TOKEN = localStorage.getItem('token');

export const useListarTiposCarga = () => {
  return useQuery(['listarTiposCarga'], async () => {
    const response = await GET('comando/listarTiposCarga');
    if (!response) throw new Error('Error al listar tipos de carga');
    return response;
  });
};

export const useListarTiposDescarga = () => {
  return useQuery(['listarTiposDescarga'], async () => {
    const response = await GET('comando/listarTiposDescarga');
    if (!response) throw new Error('Error al listar tipos de descarga');
    return response;
  });
};

export const useLimpiarCache = () => {
  return useMutation(async () => await POST({}, 'comando/clearCache'), {
    onSuccess: (response) => {
      notification['success']({ message: response.mensaje || 'Cache limpiada' });
    },
    onError: (error) => {
      if (error.response && error.response.data?.mensaje) {
        notification['error']({ message: error.response.data.mensaje });
      } else {
        notification['error']({ message: 'Error al limpiar cache' });
      }
    },
  });
};

export const useRectificacion = () => {
  return useMutation(async (data = {}) => await POST(data, 'comando/rectificacion'), {
    onSuccess: (response) => {
      notification['success']({ message: response.mensaje || 'Rectificación ejecutada' });
    },
    onError: (error) => {
      if (error.response && error.response.data?.mensaje) {
        notification['error']({ message: error.response.mensaje });
      } else {
        notification['error']({ message: 'Error al ejecutar rectificación' });
      }
    },
  });
};

export const useCustomComando = () => {
  return useMutation(async (data) => await POST(data, 'comando/customComando'), {
    onSuccess: (response) => {
      notification['success']({ message: response.mensaje || 'Comando ejecutado' });
    },
    onError: (error) => {
      if (error.response && error.response.data?.mensaje) {
        notification['error']({ message: error.response.data.mensaje });
      } else {
        notification['error']({ message: 'Error al ejecutar comando' });
      }
    },
  });
};

export const useDescargarCsvEjemplo = () => {
  return useMutation(async (tipo) => {
    const response = await axios.get(`${API_URL}comando/descargarCsvEjemplo`, {
      responseType: 'blob',
      params: { tipo },
      headers: { Authorization: TOKEN },
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${tipo}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  });
};

export const useImportarCsv = () => {
  return useMutation(async ({ tipo, file }) => {
    const formData = new FormData();
    formData.append('tipo', tipo);
    formData.append('file', file);
    
    const res = await axios.post(`${API_URL}comando/importarCsv`, formData, {
      headers: { 
        Authorization: TOKEN,
        'Content-Type': 'multipart/form-data'
      },
    });
    return res.data;
  }, {
    onSuccess: (response) => {
      notification['success']({ message: response.mensaje || 'Archivo importado correctamente' });
    },
    onError: (error) => {
      if (error.response && error.response.data?.mensaje) {
        notification['error']({ message: error.response.data.mensaje });
      } else {
        notification['error']({ message: 'Error al importar archivo' });
      }
    }
  });
};

export const useExportarCsv = () => {
  return useMutation(async (tipo) => {
    const response = await axios.get(`${API_URL}comando/exportarCsv`, {
      responseType: 'blob',
      params: { tipo },
      headers: { Authorization: TOKEN },
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${tipo}_export.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    notification.success({
      message: 'Descarga completada',
      description: `El archivo ${tipo}_export.csv se ha descargado correctamente`,
    });
    
    return true;
  }, {
    onError: (error) => {
      if (error.response && error.response.mensaje) {
        notification.error({ 
          message: 'Error al descargar',
          description: error.response.mensaje 
        });
      } else {
        notification.error({ 
          message: 'Error al descargar',
          description: 'No se pudo generar la descarga del archivo :c' 
        });
      }
    }
  });
};
